import { FC } from 'react'
import {
    Outlet
} from "react-router-dom";


const ShopPage: FC = () => {  
    return (
        <Outlet />
    );
}

export default ShopPage